import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { HeartCrackIcon, MoonIcon, BriefcaseIcon, AlertTriangleIcon } from 'lucide-react';
const painPoints = [{
  icon: HeartCrackIcon,
  text: 'Ves a tus hijos salir de casa y un nudo en el estómago no te deja tranquila hasta que regresan.'
}, {
  icon: MoonIcon,
  text: 'Te acuestas a dormir, pero tu mente no para de dar vueltas pensando en las deudas o los peligros de "afuera".'
}, {
  icon: BriefcaseIcon,
  text: 'Sientes que, por más que trabajas, la paz se escapa de tus manos como agua.'
}];
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-12 sm:py-16 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #0A1628 0%, #0D1F3C 100%)'
  }} data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-8" data-id="element-56">
          <div className="flex justify-center mb-3" data-id="element-57">
            <AlertTriangleIcon size={32} className="text-gold-warm" data-id="element-58" />
          </div>
          <h2 className="font-cinzel font-bold text-2xl sm:text-3xl md:text-4xl mb-4" style={{
          color: '#FFF8E7'
        }} data-id="element-59">
            ¿Te suena familiar esta sensación?
          </h2>
          <div className="divider-gold mx-auto" style={{
          width: '140px'
        }} data-id="element-60" />
        </motion.div>

        {/* Pain points */}
        <div className="space-y-4 mb-8" data-id="element-61">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -40
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2 + index * 0.15
          }} className="flex items-start gap-4 p-4 sm:p-5 rounded-xl border" style={{
            background: 'rgba(27,58,107,0.3)',
            borderColor: 'rgba(201,168,76,0.2)'
          }} data-id="element-62">
                <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center" style={{
              background: 'rgba(201,168,76,0.15)',
              border: '1px solid rgba(201,168,76,0.4)'
            }} data-id="element-63">
                  <Icon size={18} className="text-gold-warm" data-id="element-64" />
                </div>
                <p className="font-lato text-base leading-relaxed" style={{
              color: 'rgba(255,248,231,0.9)'
            }} data-id="element-65">
                  {point.text}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Truth statement */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.7
      }} className="text-center p-6 rounded-2xl border" style={{
        background: 'linear-gradient(135deg, rgba(27,58,107,0.5) 0%, rgba(10,22,40,0.8) 100%)',
        borderColor: 'rgba(201,168,76,0.4)'
      }} data-id="element-66">
          <p className="font-lato text-base sm:text-lg leading-relaxed" style={{
          color: '#FFF8E7'
        }} data-id="element-67">
            <strong className="font-cinzel text-gold-light" data-id="element-68">
              La verdad es esta:
            </strong>{' '}
            Vivimos en tiempos inciertos. Pero no tienes que enfrentarlos sola.
            Hay una fuerza más grande que cualquier peligro, y está esperando a
            que <strong className="text-gold-light" data-id="element-69">tú la actives.</strong>
          </p>
        </motion.div>
      </div>
    </section>;
}